module.exports = __webpack_public_path__ + "static/media/SF_nn_engl_sentrert_logo_agder_pos.3689887b.svg";